// extracted by mini-css-extract-plugin
export default {"wrapper":"JM5OSD","frame":"mr3By0","frame--mobile":"tSfiH1","result":"UKZCaK","normal":"blQzTl","column":"jJWVde"};